
import { defineComponent } from "vue";
import dayjs from "dayjs";
import { images } from "@/mixins/images";
import { MMIUser } from "@/store/MMI/MMIInterfaces";

export default defineComponent({
  name: "mmi-user-card",
  props: {
    userData: {
      type: Object as () => MMIUser,
      required: true,
    },
    // Ya no hay prop `chapter`: lo único que la usaba era la URL
    // `/mastermind-intensive/<capítulo>`, y la ruta se aplanó a `/acelerador`.
    // El capítulo sigue existiendo en los datos, pero lo lleva el padre.
  },
  data() {
    return {
      profilePictureUrl: "",
    };
  },
  computed: {
    userInitialDate(): string {
      const d: Date =
        (this.userData.initialDate as any)._seconds !== undefined
          ? new Date((this.userData.initialDate as any)._seconds * 1000)
          : this.userData.initialDate;
      return d.getTime() === 0 ? "-" : dayjs(d).format("YYYY/MM/DD HH:mm:ss z");
    },
  },
  created() {
    this.getProfilePicture(this.userData.profilePicture).then((response) => {
      this.profilePictureUrl = response;
    });
  },
  setup() {
    const getProfilePicture = images.methods.getProfilePicture;
    return {
      getProfilePicture,
    };
  },
});
